import React from "react";
import { useState } from 'react';
import { Helmet } from "react-helmet";
import { NavLink } from 'react-router-dom';


function Training()
{
    return (
        <div>
            <Helmet>
                <title>Training| Lucas RODRIGUEZ</title>
            </Helmet>
            <p><i className="fa fa-arrow-left"></i>&nbsp; <NavLink to="/">Home</NavLink></p>

            <h2>Trainings</h2>

            <p>Future training</p>

            <hr class="col-3 col-md-2 mb-5" />


        </div >
    );
}
export default Training;